import ResponsiveTable from "../../web/app/themes/mchgroup-gb/js/Classes/ResponsiveTable";
import Gri from "./Classes/Gri";

export default {

  version: () => {
    return NSContext.theme.version;
  },

};

document.addEventListener("DOMContentLoaded", function () {
  new ResponsiveTable({
    tableSelector: '.ns-table-wrap table',
    tableWrapperSelector: '.ns-table-wrap',
    breakPointLg: 1200,
    breakPointMd: 768,
    breakPointSm: 480,
    colCountNoSplit: 3,
    colCountEarlyBreak: 7,
    noSplitArray: []
  });

  new Gri();
});
